module.exports = __webpack_public_path__ + "static/trioimg5-a0deda1d3596284279c7e6b28fb1e6e5.jpg";